import { render, staticRenderFns } from "./Facet.vue?vue&type=template&id=343e25e0&scoped=true&"
import script from "./Facet.vue?vue&type=script&lang=js&"
export * from "./Facet.vue?vue&type=script&lang=js&"
import style0 from "./Facet.vue?vue&type=style&index=0&id=343e25e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343e25e0",
  null
  
)

export default component.exports